import { CmsApiDonateBlockData } from 'modules/cms/api/types/CmsApiDonate';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsDonateBlock } from './CmsDonateBlock';

export const CmsDonateBlockMapping: CmsBlockMapping<CmsApiDonateBlockData> = {
  invariant: [],
  width: CmsBlockWidth.FULL,
  Component: CmsDonateBlock,
  AmpComponent: CmsDonateBlock,
};
